import React, { useEffect, useState } from 'react';

import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';

import { getData, getPerfil } from '../../../../services/auth';

// import { Link } from 'react-router-dom';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBSwitch,
  MDBCardText,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBCardHeader,
} from 'mdbreact';

import api from '../../../../services/api';
import { format, parseISO, setSeconds } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';
import Loading from '../../../../components/Loading';
import { toast } from 'react-toastify';
import NavBar from '../../../../components/NavBar';

// opcao sintetica "Todas as gerencias" no select (value especial)
const OPCAO_TODAS = { label: 'Todas as gerências', value: '__todas__' };

// import { Container } from './styles';

export default function ListagemBdts(props) {
  let history = useHistory();

  const [loadingSelect, setLoadingSelect] = useState(false);

  const [loadingData, setLoadingData] = useState(false);

  const [listSelectVtr, setListSelectVtr] = useState([]);
  const [vtrSelected, setVtrSelected] = useState(null);

  const [data, setData] = useState([]);
  const [listaGerencias, setListaGerencias] = useState([]);
  const [gerenciaSelecionada, setGerenciaSelecionada] = useState(null);

  const [dataApresentacao, setDataApresentacao] = useState(null);
  const [dataDispensa, setDataDispensa] = useState(null);
  const listarVtrs = async () => {
    setLoadingSelect(true);
    let selectPlacas = [];
    if (ehTodasGerencias) {
      // "Todas as gerencias": /frota-veiculos nao tem um modo "todas", entao
      // busca as placas via /frota SEM gerencia_id (retorna todas as VTRs).
      const result = await api.get('/frota', { params: { ativo: true } });
      selectPlacas = result.data
        .filter(vtr => vtr.placa)
        .map(vtr => ({ label: vtr.placa, value: vtr.id }))
        .sort((a, b) => a.label.localeCompare(b.label));
    } else {
      const result = await api.get('/frota-veiculos', {
        params: {
          // excessaoVtrPosto: true,
          id: gerenciaSelecionada.value,
        },
      });
      result.data.forEach(vtr => {
        selectPlacas.push({ label: vtr.placa, value: vtr.id });
      });
    }

    setListSelectVtr(selectPlacas);
    setLoadingSelect(false);
  };

  const buscaBdt = async () => {
    if (gerenciaSelecionada === null) {
      toast.error('Selecione Gerência');
      return;
    }
    const params = {};
    if (ehTodasGerencias) {
      // "Todas as gerencias": com uma VTR escolhida, filtra por ela; SEM
      // viatura, a busca e ampla e exige periodo (Data Inicio e Data Fim).
      if (vtrSelected !== null) {
        params.fk_veiculos_id = vtrSelected.value;
      } else if (dataApresentacao === null || dataDispensa === null) {
        toast.error(
          'Para "Todas as gerências" sem viatura, informe Data Início e Data Fim.'
        );
        return;
      }
    } else {
      // fluxo por viatura: exige a VTR
      if (vtrSelected === null) {
        toast.error('Selecione Viatura');
        return;
      }
      params.fk_veiculos_id = vtrSelected.value;
    }
    if (dataApresentacao !== null) {
      params.data_apresentacao = parseISO(dataApresentacao);
    }
    if (dataDispensa !== null) {
      params.data_dispensa = dataDispensa;
    }
    setLoadingData(true);
    try {
      const result = await api.get('/bdts-vtr', { params });
      if (result.data && result.data.erro) {
        toast.error(result.data.erro);
        setData([]);
      } else {
        setData(result.data);
      }
    } catch (e) {
      toast.error('Falha ao buscar os boletins');
    }
    setLoadingData(false);
  };

  const carregaGerencias = () => {
    api.get('/filtra-gerencia').then(linhas => {
      let select = [];
      linhas.data.map(linha => {
        select.push({
          label: linha.nome,
          value: String(linha.id),
        });
      });
      // "Todas as gerencias" como primeira opcao (busca de todas as viaturas)
      setListaGerencias([OPCAO_TODAS, ...select]);
    });
  };

  // true quando a opcao "Todas as gerencias" esta selecionada
  const ehTodasGerencias =
    gerenciaSelecionada && gerenciaSelecionada.value === OPCAO_TODAS.value;

  // ADD NOVO BDT
  useEffect(() => {
    carregaGerencias();
  }, []);

  useEffect(() => {
    // carrega as VTRs da gerencia escolhida; em "Todas as gerencias" carrega
    // TODAS as placas (o filtro por viatura continua opcional nesse modo).
    if (gerenciaSelecionada !== null) {
      listarVtrs();
    } else {
      setListSelectVtr([]);
    }
    setVtrSelected(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gerenciaSelecionada]);

  // ---- EXPORTACAO (CSV / XLSX / PDF) do resultado exibido ----
  const dataHora = valor => {
    if (!valor) return '';
    try {
      return format(new Date(valor), 'dd/MM/yyyy HH:mm');
    } catch (e) {
      return '';
    }
  };

  // achata cada boletim numa linha (1 boletim = 1 linha), com resumo das
  // ocorrencias e abastecimentos concatenados.
  const montaLinhasExport = () =>
    (data || []).map(bdt => {
      const ocorrencias = (bdt.bdts_ocorrencias || [])
        .map(oco => {
          const tipo = oco.tipo_bdts_ocorrencia
            ? oco.tipo_bdts_ocorrencia.tipo_ocorrencia
            : '';
          const desc = oco.descricao || '';
          return `${tipo}${desc ? `: ${desc}` : ''}`;
        })
        .join(' | ');
      const abastecimentos = (bdt.abastecimentos || [])
        .map(ab => {
          const tipo = ab.tipos_combustivei
            ? ab.tipos_combustivei.tipo_combustivel
            : '';
          return `${dataHora(ab.data_abastecimento)} ${tipo} ${
            ab.quantidade || 0
          }L KM ${ab.quilometragem || ''} R$ ${ab.valor_total || ''}`;
        })
        .join(' | ');

      return {
        Usuario: bdt.usuario ? bdt.usuario.nome_social : '',
        'Data Apresentação': dataHora(bdt.data_apresentacao),
        'Data Dispensa': bdt.data_dispensa
          ? dataHora(bdt.data_dispensa)
          : 'BDT ABERTO',
        'KM Inicial': bdt.quilometragem_inicio || '',
        Exceção: bdt.excessao === true ? 'Sim' : 'Não',
        Justificativa: bdt.excessao === true ? bdt.excessao_justificativa || '' : '',
        Ocorrências: ocorrencias,
        Abastecimentos: abastecimentos,
      };
    });

  const nomeBaseArquivo = () => {
    const g = ehTodasGerencias
      ? 'todas'
      : (gerenciaSelecionada && gerenciaSelecionada.label) || 'gerencia';
    return `bdt_${String(g).replace(/[^\w]+/g, '_').toLowerCase()}`;
  };

  const semDados = () => {
    if (!data || data.length === 0) {
      toast.error('Nada para exportar. Faça uma busca primeiro.');
      return true;
    }
    return false;
  };

  const exportarXLSX = () => {
    if (semDados()) return;
    const linhas = montaLinhasExport();
    const ws = XLSX.utils.json_to_sheet(linhas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Boletins');
    XLSX.writeFile(wb, `${nomeBaseArquivo()}.xlsx`);
  };

  const exportarCSV = () => {
    if (semDados()) return;
    const linhas = montaLinhasExport();
    const colunas = Object.keys(linhas[0]);
    const escapa = v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`;
    const conteudo = [
      colunas.map(escapa).join(';'),
      ...linhas.map(l => colunas.map(c => escapa(l[c])).join(';')),
    ].join('\r\n');
    // BOM p/ acentuacao correta no Excel
    const blob = new Blob([`﻿${conteudo}`], {
      type: 'text/csv;charset=utf-8;',
    });
    saveAs(blob, `${nomeBaseArquivo()}.csv`);
  };

  const exportarPDF = () => {
    if (semDados()) return;
    const linhas = montaLinhasExport();
    const colunas = Object.keys(linhas[0]);
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    doc.setFontSize(12);
    doc.text('Boletins de Tráfego', 14, 14);
    doc.autoTable({
      startY: 20,
      head: [colunas],
      body: linhas.map(l => colunas.map(c => l[c])),
      styles: { fontSize: 7, cellPadding: 1.5, overflow: 'linebreak' },
      headStyles: { fillColor: [89, 105, 141] },
      columnStyles: {
        6: { cellWidth: 60 }, // Ocorrencias
        7: { cellWidth: 70 }, // Abastecimentos
      },
      margin: { left: 8, right: 8 },
    });
    doc.save(`${nomeBaseArquivo()}.pdf`);
  };

  return (
    <NavBar>
      <MDBContainer>
        <MDBRow className="align-items-end">
          <MDBCol size="12" md="3">
            <Select
              className="font-weight-bolder"
              options={listaGerencias}
              placeholder="Gerência"
              onChange={e => setGerenciaSelecionada(e)}
              // isLoading={loadingSelect}
            />
          </MDBCol>
          <MDBCol size="12" md="3">
            <Select
              className="font-weight-bolder"
              options={listSelectVtr}
              placeholder={
                ehTodasGerencias ? 'Todas as viaturas' : 'Selecione VTR'
              }
              onChange={e => setVtrSelected(e)}
              value={vtrSelected}
              isLoading={loadingSelect}
              isClearable={ehTodasGerencias}
            />
          </MDBCol>
          <MDBCol size="12" md="3">
            <div>Data Início</div>
            <input
              className="border border-light w-100 rounded grey-text"
              style={{ padding: '.375rem .75rem' }}
              type="date"
              outline
              // className="bg-white"
              label="Data Inicio"
              onChange={e => setDataApresentacao(`${e.target.value} 00:00`)}
            />
          </MDBCol>
          <MDBCol size="12" md="3">
            <div>Data Fim</div>
            <input
              className="border border-light w-100 rounded grey-text"
              style={{ padding: '.375rem .75rem' }}
              type="date"
              outline
              // className="bg-white"
              label="Data Fim"
              onChange={e => setDataDispensa(`${e.target.value} 23:59`)}
            />
          </MDBCol>
        </MDBRow>
        <MDBRow className="mt-2" center>
          <MDBBtn
            onClick={() => {
              buscaBdt();
            }}
            size="sm"
          >
            Buscar
          </MDBBtn>
        </MDBRow>

        {/* exportar o resultado exibido */}
        {data && data.length > 0 && (
          <MDBRow className="mt-1" center>
            <span className="align-self-center mr-2 grey-text">
              Exportar ({data.length}):
            </span>
            <MDBBtn color="success" size="sm" onClick={exportarXLSX}>
              <MDBIcon icon="file-excel" className="mr-1" />
              XLSX
            </MDBBtn>
            <MDBBtn color="info" size="sm" onClick={exportarCSV}>
              <MDBIcon icon="file-excel-o" className="mr-1" />
              CSV
            </MDBBtn>
            <MDBBtn color="danger" size="sm" onClick={exportarPDF}>
              <MDBIcon icon="file-pdf" className="mr-1" />
              PDF
            </MDBBtn>
          </MDBRow>
        )}

        {loadingData ? (
          <Loading />
        ) : (
          <>
            {/* <MDBRow className="m-5 h4-responsive">
              <MDBCol>Placa: {data?.placa}</MDBCol>
              <MDBCol>Modelo: {data?.modelo}</MDBCol>
            </MDBRow> */}
            {data.length === 0 ? (
              <MDBRow
                center
                className="mt-3 h5-responsive text-danger font-weight-bolder"
              >
                Vazio
              </MDBRow>
            ) : (
              <>
                {data?.map(bdt => (
                  <MDBCard className="my-4" key={`bdt${bdt.id}`}>
                    <MDBCardBody>
                      <MDBRow>
                        <MDBCol className="text-danger">
                          Usuario:
                          {bdt?.usuario?.nome_social}
                        </MDBCol>
                      </MDBRow>
                      <MDBRow className="mt-2">
                        <MDBCol>
                          Data Apresentacao:
                          <br />
                          {format(
                            new Date(bdt?.data_apresentacao),
                            'dd/MM/yyyy HH:mm'
                          )}
                        </MDBCol>

                        <MDBCol>
                          Data Dispensa:
                          <br />
                          {bdt.data_dispensa === null ? (
                            <div className="text-danger font-weight-bolder">
                              BDT ABERTO
                            </div>
                          ) : (
                            format(
                              new Date(bdt?.data_dispensa),
                              'dd/MM/yyyy HH:mm'
                            )
                          )}
                        </MDBCol>
                        <MDBCol>
                          KM Inicial:
                          <br />
                          {bdt?.quilometragem_inicio}
                        </MDBCol>
                      </MDBRow>
                      <MDBRow className="mt-2">
                        <MDBCol>
                          Foi Excessão:
                          {bdt?.excessao === true ? ' Sim' : ' Não'}
                        </MDBCol>
                      </MDBRow>
                      {bdt?.excessao === true ? (
                        <MDBRow>
                          <MDBCol>
                            Justificatica:
                            {bdt?.excessao_justificativa}
                          </MDBCol>
                        </MDBRow>
                      ) : (
                        ''
                      )}
                      <MDBRow className="h4-responsive mt-4">
                        <MDBCol>Ocorrências</MDBCol>
                      </MDBRow>
                      {bdt?.bdts_ocorrencias?.map(oco => (
                        <div
                          key={`oc${oco.id}`}
                          className="border-top border-light"
                        >
                          <MDBRow className="mt-3">
                            <MDBCol>
                              Criado em:{' '}
                              {format(
                                new Date(oco?.createdAt),
                                'dd/MM/yyyy HH:mm'
                              )}
                            </MDBCol>
                            <MDBCol>
                              Tipo: {oco?.tipo_bdts_ocorrencia?.tipo_ocorrencia}
                            </MDBCol>
                          </MDBRow>

                          <MDBRow>
                            <MDBCol>Descrição: {oco?.descricao}</MDBCol>
                          </MDBRow>
                        </div>
                      ))}
                      <MDBRow className="h4-responsive mt-4">
                        <MDBCol>Abastecimento</MDBCol>
                      </MDBRow>
                      {bdt?.abastecimentos?.map(abas => (
                        <div
                          key={`ab${abas.id}`}
                          className="border-top border-light"
                        >
                          <MDBRow className="mt-3">
                            <MDBCol>
                              Data:{' '}
                              {format(
                                new Date(abas?.data_abastecimento),
                                'dd/MM/yyyy HH:mm'
                              )}
                            </MDBCol>
                            <MDBCol>
                              Tipo: {abas?.tipos_combustivei?.tipo_combustivel}
                            </MDBCol>
                          </MDBRow>

                          <MDBRow>
                            <MDBCol>
                              Quantidade: <br />
                              {abas?.quantidade} Litros
                            </MDBCol>
                            <MDBCol>
                              KM de Abastecimento: <br /> {abas?.quilometragem}
                            </MDBCol>
                            <MDBCol>
                              Valor Total: <br />
                              R$: {abas?.valor_total}
                            </MDBCol>
                          </MDBRow>
                        </div>
                      ))}
                    </MDBCardBody>
                  </MDBCard>
                ))}
              </>
            )}
          </>
        )}
        <br />
      </MDBContainer>
    </NavBar>
  );
}
